import React from 'react';

export const LocationMap = () => {
  // const onButtonClick = () => {
  //   fetch('https://openslava.sk/Openslava2022_mapa.pdf', {
  //     method: 'GET',
  //     headers: {
  //       'Content-Type': 'application/pdf'
  //     }
  //   }).then(response => {
  //     response.blob().then(() => {
  //       const alink = document.createElement('a');
  //       alink.href = 'https://openslava.sk/Openslava2022_mapa.pdf';
  //       alink.download = './Openslava2022_mapa.pdf';
  //       alink.click();
  //     });
  //   });
  // };

  return (
    <section id="location-map-section">
      <div className="column is-12-desktop is-12-tablet is-12-mobile">
        {/* <div className="title">
          <h1>LOCATION MAP COMING SOON</h1>
        </div> */}
        <img alt="location-map" src="imgs/conference_map.jpg" />
        {/* <button className="button" onClick={onButtonClick} type="button">
          <span className="fa-stack is-large">
            <i className="fas fa-circle fa-stack-2x" />
            <i className="fas fa-angle-right fa-lg fa-stack-1x" />
          </span>
          <span className="button-text">Download PDF</span>
        </button> */}
      </div>
    </section>
  );
};

export default LocationMap;
